import type { FaireProductEntity } from "../../entity_types/product";

export const p_nfxpqeyqzr: FaireProductEntity = {
  token: "p_nfxpqeyqzr",
  type: "product",
  name: "dahlia mini enclosure notecard",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/b52f92bbe625017c623bdd493628b6050ecc755ce475e0fdc1cea8a33a4a8026.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/45d248300160564f75824f0f5ceef645dd45089e42704652f5e22c137c8f40be.jpeg",
    "https://cdn.faire.com/fastly/512a716678bea03ea26a70dc65e600bcf37a7880b059e89e40af8f11fc70522a.jpeg",
    "https://cdn.faire.com/fastly/9b908cc16b31d3b75dcd4b7083b17ec04340ea4febce8af233d4ab1336c2db87.jpeg",
    "https://cdn.faire.com/fastly/54e68a17891bf9b2a5ed7291ee794664e9976bed7e87b0277078a6f5e1cd9c0b.jpeg",
    "https://cdn.faire.com/fastly/77cde735bec62ab375f111ef525b13a7368c3631cba4ed1fc74d5ec1ea609b11.jpeg",
  ],
  priceDollars: 3,
  description:
    'A mini notecard for petite greetings. Perfect for adding to a gift or popping in a gift card for a pretty (and easy!) presentation. \n\n\nDetails:\n\n- single card + envelope + sticker for sealing\n- blank inside\n- 2.5" x 3.5"\n- Printed on 120lb superfine paper\n- Original watercolor artwork by Emily Lex\n',
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-28T05:30:10.108Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
